import React, { useState } from 'react'
import styled from 'styled-components'
import { Close } from '../../../../../../components/Icons'
import ErrorBoundary from '../../../../../../components/ErrorBoundary'

const ErrorContainer = styled.div`
  width: 100%;
  display: ${props => props.hide ? 'none' : 'flex'};
  flex-direction: row;
  align-items: center;
`;

// One inline run of text, so the sentence wraps as a sentence instead of
// three flex columns side by side.
const Message = styled.span`
  flex: 1;
  font-family: Hind;
  font-weight: 300;
  font-size: 16px;
  color: #000000;
  letter-spacing: 0;
`

const FileName = styled.span`
  font-weight: 400;
  cursor: pointer;
  word-break: break-all;
`

const UploadError = ({ error, image, text, onHover}) => {
  const [hide, setHide] = useState(false)

  return (
    <ErrorBoundary>
      <ErrorContainer hide={hide}>
        <Close color='#F3DBC7' scale={3} onClick={() => setHide(true)} style={{marginRight: 10, cursor: 'pointer', flexShrink: 0}} />
        <Message>
          {text}{' '}
          <FileName
            onMouseEnter={() => onHover(image.preview)}
            onMouseLeave={() => onHover(null)}
          >
            {image.original_filename || image.name}
          </FileName>{' '}
          {error}
        </Message>
      </ErrorContainer>
    </ErrorBoundary>
  )
}

export default UploadError
